module.exports = __webpack_public_path__ + "static/media/hashtag-nft-24.bb75c668.jpg";